module.exports = require("./ar-SD.d.ts");